<template>
  <Radar
    v-if="loaded"
    :data="chartData"
    :options="chartOptions"
    :plugins="chartPlugins"
  />
</template>

<script>
import { Radar } from "vue-chartjs";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  RadialLinearScale,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  RadialLinearScale
);

export default {
  components: { Radar },

  data() {
    return {
      loaded: false,
      chartData: {
        labels: [
          "Momento 1",
          "Momento 2",
          "Momento 3",
          "Momento 4",
          "Momento 5",
          "Momento 6",
        ],
        datasets: [
          {
            label: "",
            data: [3, 3, 4, 2, 1, 5],
            fill: true,
            backgroundColor: "#0cc2b761",
            borderColor: "#0cc2b7",
            pointBackgroundColor: "#1b5af861",
            pointBorderColor: "#0cc2b7",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#0cc2b7",
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            min: 0,
            max: 5,
            angleLines: {
              color: "#FFFFFF41",
            },
            pointLabels: {
              color: "#FFFFFF",
            },
            grid: {
              color: "#FFFFFF41",
            },
            ticks: {
              backdropColor: "transparent",
              color: "#FFFFFF",
            },
          },
        },
        elements: {
          line: {
            borderWidth: 2,
          },
        },
        plugins: {
          customCanvasBackgroundColor: false,
          title: {
            display: true,
            align: "start",
            text: "Gráfica de Resultado de Valoraciones",
            color: "#FFFFFF",
          },

          legend: {
            display: false,
          },
        },
      },
      chartPlugins: [
        {
          id: "customCanvasBackgroundColor",
          beforeDraw: (chart, args, options) => {
            const { ctx } = chart;
            ctx.save();
            ctx.globalCompositeOperation = "destination-over";
            ctx.fillStyle = options.color || "#99ffff";
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
          },
        },
      ],
    };
  },

  props: ["labelsProp", "dataProp"],

  watch: {
    dataProp() {
      this.loaded = false;
      this.chartData.labels = this.labelsProp;
      this.chartData.datasets[0].data = this.dataProp;
      this.loaded = true;
    },
  },

  mounted() {
    this.chartData.labels = this.labelsProp;
    this.chartData.datasets[0].data = this.dataProp;
    this.loaded = true;
    // console.log(this.dataProp);
    // console.log(this.labelsProp);
  },
};
</script>

<style></style>
